import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getHoldingList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditHoldingModal from './Add_Edit/AddEditHolding';
import DeleteHoldingModal from './Delete/DeleteHolding';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const HoldingsList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorHoldings = createSelector(
		state => state.Holdings,
		holding => ({
			holdingList: holding.holdingList,
			isLoadingList: holding.isLoadingList,
			isHoldingSuccess: holding.isHoldingSuccess,
			error: holding.error,
			isAdding: holding.isAdding,
			isAdded: holding.isAdded,
			isAddError: holding.isAddError,
			isUpdating: holding.isUpdating,
			isUpdated: holding.isUpdated,
			isUpdateError: holding.isUpdateError,
			isDeleting: holding.isDeleting,
			isDeleted: holding.isDeleted,
			isDeleteError: holding.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { holdingList, isLoadingList } = useSelector(selectorHoldings);

	useEffect(() => {
		dispatch(getHoldingList());
	}, []);

	const [dataHolding, setDataHolding] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Holding
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = holding => {
		setDataHolding(holding);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = holding => {
		setDataHolding(holding);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'holding',
				columnDefType: 'display',
				 size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const holdingData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(holdingData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const holdingData =
														cellProps.row.original;
													handleClickDelete(holdingData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
				
				size: 'auto'
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataHolding({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Holding
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={holdingList || []}
								isLoadingData={isLoadingList}
								nameFile={'holding'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
												setIsEdit(false);
												setDataHolding({});
												handleToggleModal();
											},
										title: 'Crear Holding',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditHoldingModal
				dataHolding={dataHolding}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteHoldingModal
				dataHolding={dataHolding}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default HoldingsList;
